import { PATHS } from "@/constants/pathnames";

export const getFooterMenuData = (category, t) => {
  const commonFooterMenu = [
    {
      key: "sirket",
      titleKey: "footer.flightmenu4title",
      items: [
        {
          href: PATHS.ABOUT_US.PATH,
          textKey: "footer.flightmenu4link1",
        },
        {
          href: "https://www.turna.com/blog/",
          textKey: "footer.flightmenu4link2",
        },
        {
          href: PATHS.PUBLIC_HOLIDAYS_PAGE.PATH,
          textKey: "footer.flightmenu4link3",
        },
      ],
    },
    {
      key: "yardim-destek",
      titleKey: "footer.flightmenu5title",
      items: [
        {
          href: PATHS.CONTACT.PATH,
          textKey: "footer.flightmenu5link1",
        },
        {
          href: PATHS.FAQ_PAGE.PATH,
          textKey: "footer.flightmenu5link2",
        },
        {
          href: "mailto:info@turna.com",
          textKey: "footer.flightmenu5link3",
        },
        {
          href: PATHS.API_SERVICE.PATH,
          textKey: "footer.flightmenu5link4",
        },
      ],
    },
    {
      key: "gizlilik-guvenlik",
      titleKey: "footer.flightmenu6title",
      items: [
        {
          href: PATHS.TERMS_OF_USE.PATH,
          textKey: "footer.flightmenu6link1",
        },
        {
          href: PATHS.PRIVACY_POLICY.PATH,
          textKey: "footer.flightmenu6link2",
        },
        {
          href: PATHS.COOKIE_POLICY.PATH,
          textKey: "footer.flightmenu6link3",
        },
        {
          href: PATHS.DATA_PROTECTION.PATH,
          textKey: "footer.flightmenu6link4",
        },
        {
          href: PATHS.COMMERCIAL_MESSAGE_CONSENT.PATH,
          textKey: "footer.flightmenu6link5",
        },
        {
          href: PATHS.SOCIAL_MEDIA_PERMISSIONS.PATH,
          textKey: "footer.flightmenu6link6",
        },
      ],
    },
  ];

  const menuData = {
    flight: [
      {
        key: "ucak-bileti",
        titleKey: "footer.flightmenu1title",
        items: [
          // {
          //   href: t("footer.flightmenu1link1Href"),
          //   textKey: "footer.flightmenu1link1",
          // },
          {
            href: t("footer.flightmenu1link2Href"),
            textKey: "footer.flightmenu1link2",
          },
          {
            href: t("footer.flightmenu1link3Href"),
            textKey: "footer.flightmenu1link3",
          },
          {
            href: t("footer.flightmenu1link4Href"),
            textKey: "footer.flightmenu1link4",
          },
          {
            href: t("footer.flightmenu1link5Href"),
            textKey: "footer.flightmenu1link5",
          },
          {
            href: t("footer.flightmenu1link6Href"),
            textKey: "footer.flightmenu1link6",
          },
        ],
      },
      {
        key: "ucak-firmalari",
        titleKey: "footer.flightmenu2title",
        items: [
          {
            href: t("footer.flightmenu2link1Href"),
            textKey: "footer.flightmenu2link1",
          },
          {
            href: t("footer.flightmenu2link2Href"),
            textKey: "footer.flightmenu2link2",
          },
          {
            href: t("footer.flightmenu2link3Href"),
            textKey: "footer.flightmenu2link3",
          },
          {
            href: t("footer.flightmenu2link4Href"),
            textKey: "footer.flightmenu2link4",
          },
          {
            href: t("footer.flightmenu2link5Href"),
            textKey: "footer.flightmenu2link5",
          },
          {
            href: t("footer.flightmenu2link6Href"),
            textKey: "footer.flightmenu2link6",
          },
        ],
      },
      {
        key: "havaalanlari",
        titleKey: "footer.flightmenu3title",
        items: [
          {
            href: t("footer.flightmenu3link1Href"),
            textKey: "footer.flightmenu3link1",
          },
          {
            href: t("footer.flightmenu3link2Href"),
            textKey: "footer.flightmenu3link2",
          },
          {
            href: t("footer.flightmenu3link3Href"),
            textKey: "footer.flightmenu3link3",
          },
          {
            href: t("footer.flightmenu3link4Href"),
            textKey: "footer.flightmenu3link4",
          },
          {
            href: t("footer.flightmenu3link5Href"),
            textKey: "footer.flightmenu3link5",
          },
          {
            href: t("footer.flightmenu3link6Href"),
            textKey: "footer.flightmenu3link6",
          },
        ],
      },
      ...commonFooterMenu,
    ],
    hotel: [
      {
        key: "otel-rezervasyonu",
        titleKey: "footer.hotelmenu1title",
        items: [
          {
            href: t("footer.hotelmenu1link1Href"),
            textKey: "footer.hotelmenu1link1",
          },
          {
            href: t("footer.hotelmenu1link2Href"),
            textKey: "footer.hotelmenu1link2",
          },
          {
            href: t("footer.hotelmenu1link3Href"),
            textKey: "footer.hotelmenu1link3",
          },
          {
            href: t("footer.hotelmenu1link4Href"),
            textKey: "footer.hotelmenu1link4",
          },
          {
            href: t("footer.hotelmenu1link5Href"),
            textKey: "footer.hotelmenu1link5",
          },
          {
            href: t("footer.hotelmenu1link6Href"),
            textKey: "footer.hotelmenu1link6",
          },
        ],
      },
      {
        key: "otel-zincirleri",
        titleKey: "footer.hotelmenu2title",
        items: [
          {
            href: t("footer.hotelmenu2link1Href"),
            textKey: "footer.hotelmenu2link1",
          },
          {
            href: t("footer.hotelmenu2link2Href"),
            textKey: "footer.hotelmenu2link2",
          },
          {
            href: t("footer.hotelmenu2link3Href"),
            textKey: "footer.hotelmenu2link3",
          },
          {
            href: t("footer.hotelmenu2link4Href"),
            textKey: "footer.hotelmenu2link4",
          },
          {
            href: t("footer.hotelmenu2link5Href"),
            textKey: "footer.hotelmenu2link5",
          },
          {
            href: t("footer.hotelmenu2link6Href"),
            textKey: "footer.hotelmenu2link6",
          },
        ],
      },
      {
        key: "populer-sehirler",
        titleKey: "footer.hotelmenu3title",
        items: [
          {
            href: t("footer.hotelmenu3link1Href"),
            textKey: "footer.hotelmenu3link1",
          },
          {
            href: t("footer.hotelmenu3link2Href"),
            textKey: "footer.hotelmenu3link2",
          },
          {
            href: t("footer.hotelmenu3link3Href"),
            textKey: "footer.hotelmenu3link3",
          },
          {
            href: t("footer.hotelmenu3link4Href"),
            textKey: "footer.hotelmenu3link4",
          },
          {
            href: t("footer.hotelmenu3link5Href"),
            textKey: "footer.hotelmenu3link5",
          },
          {
            href: t("footer.hotelmenu3link6Href"),
            textKey: "footer.hotelmenu3link6",
          },
        ],
      },
      ...commonFooterMenu,
    ],
    "car-rental": [
      {
        key: "arac-kiralama",
        titleKey: "footer.carmenu1title",
        items: [
          {
            href: t("footer.carmenu1link1Href"),
            textKey: "footer.carmenu1link1",
          },
          {
            href: t("footer.carmenu1link2Href"),
            textKey: "footer.carmenu1link2",
          },
          {
            href: t("footer.carmenu1link3Href"),
            textKey: "footer.carmenu1link3",
          },
          {
            href: t("footer.carmenu1link4Href"),
            textKey: "footer.carmenu1link4",
          },
          {
            href: t("footer.carmenu1link5Href"),
            textKey: "footer.carmenu1link5",
          },
          {
            href: t("footer.carmenu1link6Href"),
            textKey: "footer.carmenu1link6",
          },
          {
            href: t("footer.carmenu1link7Href"),
            textKey: "footer.carmenu1link7",
          },
          {
            href: t("footer.carmenu1link8Href"),
            textKey: "footer.carmenu1link8",
          },
        ],
      },
      {
        key: "arac-firmalari",
        titleKey: "footer.carmenu2title",
        items: [
          {
            href: t("footer.carmenu2link1Href"),
            textKey: "footer.carmenu2link1",
          },
          {
            href: t("footer.carmenu2link2Href"),
            textKey: "footer.carmenu2link2",
          },
          {
            href: t("footer.carmenu2link3Href"),
            textKey: "footer.carmenu2link3",
          },
          {
            href: t("footer.carmenu2link4Href"),
            textKey: "footer.carmenu2link4",
          },
          {
            href: t("footer.carmenu2link5Href"),
            textKey: "footer.carmenu2link5",
          },
          {
            href: t("footer.carmenu2link6Href"),
            textKey: "footer.carmenu2link6",
          },

          {
            href: t("footer.carmenu2link7Href"),
            textKey: "footer.carmenu2link7",
          },
          {
            href: t("footer.carmenu2link8Href"),
            textKey: "footer.carmenu2link8",
          },
        ],
      },
      {
        key: "populer-lokasyonlar",
        titleKey: "footer.carmenu3title",
        items: [
          {
            href: t("footer.carmenu3link1Href"),
            textKey: "footer.carmenu3link1",
          },
          {
            href: t("footer.carmenu3link2Href"),
            textKey: "footer.carmenu3link2",
          },
          {
            href: t("footer.carmenu3link3Href"),
            textKey: "footer.carmenu3link3",
          },
          {
            href: t("footer.carmenu3link4Href"),
            textKey: "footer.carmenu3link4",
          },
          {
            href: t("footer.carmenu3link5Href"),
            textKey: "footer.carmenu3link5",
          },
          {
            href: t("footer.carmenu3link6Href"),
            textKey: "footer.carmenu3link6",
          },
          {
            href: t("footer.carmenu3link7Href"),
            textKey: "footer.carmenu3link7",
          },
          {
            href: t("footer.carmenu3link8Href"),
            textKey: "footer.carmenu3link8",
          },
        ],
      },
      {
        key: "sirket",
        titleKey: "footer.carmenu4title",
        items: [
          {
            href: t("footer.carmenu4link1Href"),
            textKey: "footer.carmenu4link1",
          },
          {
            href: t("footer.carmenu4link2Href"),
            textKey: "footer.carmenu4link2",
          },
          {
            href: t("footer.carmenu4link3Href"),
            textKey: "footer.carmenu4link3",
          },
          {
            href: t("footer.carmenu4link4Href"),
            textKey: "footer.carmenu4link4",
          },
          {
            href: t("footer.carmenu4link5Href"),
            textKey: "footer.carmenu4link5",
          },
        ],
      },
      {
        key: "international-services",
        titleKey: "footer.carmenu5title",
        items: [
          {
            href: t("footer.carmenu5link1Href"),
            textKey: "footer.carmenu5link1",
          },
          {
            href: t("footer.carmenu5link2Href"),
            textKey: "footer.carmenu5link2",
          },
          {
            href: t("footer.carmenu5link3Href"),
            textKey: "footer.carmenu5link3",
          },
          {
            href: t("footer.carmenu5link4Href"),
            textKey: "footer.carmenu5link4",
          },
          {
            href: t("footer.carmenu5link5Href"),
            textKey: "footer.carmenu5link5",
          },
          {
            href: t("footer.carmenu5link6Href"),
            textKey: "footer.carmenu5link6",
          },
          {
            href: t("footer.carmenu5link7Href"),
            textKey: "footer.carmenu5link7",
          },
          {
            href: t("footer.carmenu5link8Href"),
            textKey: "footer.carmenu5link8",
          },
        ],
      },
      ...commonFooterMenu,
    ],
    ferry: [
      {
        key: "feribot-bileti",
        titleKey: "footer.ferrymenu1title",
        items: [
          {
            href: t("footer.ferrymenu1link1Href"),
            textKey: "footer.ferrymenu1link1",
          },
          {
            href: t("footer.ferrymenu1link2Href"),
            textKey: "footer.ferrymenu1link2",
          },
          {
            href: t("footer.ferrymenu1link3Href"),
            textKey: "footer.ferrymenu1link3",
          },
          {
            href: t("footer.ferrymenu1link4Href"),
            textKey: "footer.ferrymenu1link4",
          },
        ],
      },
      {
        key: "feribot-firmalari",
        titleKey: "footer.ferrymenu2title",
        items: [
          {
            href: t("footer.ferrymenu2link1Href"),
            textKey: "footer.ferrymenu2link1",
          },
          {
            href: t("footer.ferrymenu2link2Href"),
            textKey: "footer.ferrymenu2link2",
          },
          {
            href: t("footer.ferrymenu2link3Href"),
            textKey: "footer.ferrymenu2link3",
          },
          {
            href: t("footer.ferrymenu2link4Href"),
            textKey: "footer.ferrymenu2link4",
          },
          {
            href: t("footer.ferrymenu2link5Href"),
            textKey: "footer.ferrymenu2link5",
          },
        ],
      },
      {
        key: "populer-rotalar",
        titleKey: "footer.ferrymenu3title",
        items: [
          {
            href: t("footer.ferrymenu3link1Href"),
            textKey: "footer.ferrymenu3link1",
          },
          {
            href: t("footer.ferrymenu3link2Href"),
            textKey: "footer.ferrymenu3link2",
          },
          {
            href: t("footer.ferrymenu3link3Href"),
            textKey: "footer.ferrymenu3link3",
          },
          {
            href: t("footer.ferrymenu3link4Href"),
            textKey: "footer.ferrymenu3link4",
          },
          {
            href: t("footer.ferrymenu3link5Href"),
            textKey: "footer.ferrymenu3link5",
          },
          {
            href: t("footer.ferrymenu3link6Href"),
            textKey: "footer.ferrymenu3link6",
          },
        ],
      },
      ...commonFooterMenu,
    ],
    "bus-ticket": [
      {
        key: "otobus-bileti",
        titleKey: "footer.busmenu1title",
        items: [
          {
            href: t("footer.busmenu1link1Href"),
            textKey: "footer.busmenu1link1",
          },
          {
            href: t("footer.busmenu1link2Href"),
            textKey: "footer.busmenu1link2",
          },
          {
            href: t("footer.busmenu1link3Href"),
            textKey: "footer.busmenu1link3",
          },
          {
            href: t("footer.busmenu1link4Href"),
            textKey: "footer.busmenu1link4",
          },
          {
            href: t("footer.busmenu1link5Href"),
            textKey: "footer.busmenu1link5",
          },
          {
            href: t("footer.busmenu1link6Href"),
            textKey: "footer.busmenu1link6",
          },
        ],
      },
      {
        key: "otobus-firmalari",
        titleKey: "footer.busmenu2title",
        items: [
          {
            href: t("footer.busmenu2link1Href"),
            textKey: "footer.busmenu2link1",
          },
          {
            href: t("footer.busmenu2link2Href"),
            textKey: "footer.busmenu2link2",
          },
          {
            href: t("footer.busmenu2link3Href"),
            textKey: "footer.busmenu2link3",
          },
          {
            href: t("footer.busmenu2link4Href"),
            textKey: "footer.busmenu2link4",
          },
          {
            href: t("footer.busmenu2link5Href"),
            textKey: "footer.busmenu2link5",
          },
          {
            href: t("footer.busmenu2link6Href"),
            textKey: "footer.busmenu2link6",
          },
        ],
      },
      {
        key: "populer-rotalar",
        titleKey: "footer.busmenu3title",
        items: [
          {
            href: t("footer.busmenu3link1Href"),
            textKey: "footer.busmenu3link1",
          },
          {
            href: t("footer.busmenu3link2Href"),
            textKey: "footer.busmenu3link2",
          },
          {
            href: t("footer.busmenu3link3Href"),
            textKey: "footer.busmenu3link3",
          },
          {
            href: t("footer.busmenu3link4Href"),
            textKey: "footer.busmenu3link4",
          },
          {
            href: t("footer.busmenu3link5Href"),
            textKey: "footer.busmenu3link5",
          },
          {
            href: t("footer.busmenu3link6Href"),
            textKey: "footer.busmenu3link6",
          },
        ],
      },
      ...commonFooterMenu,
    ],
    common: [
      {
        key: "flight-services",
        titleKey: "footer.commonmenu1title",
        items: [
          {
            href: t("footer.commonmenu1link1Href"),
            textKey: "footer.commonmenu1link1",
          },
          {
            href: t("footer.commonmenu1link2Href"),
            textKey: "footer.commonmenu1link2",
          },
          {
            href: t("footer.commonmenu1link3Href"),
            textKey: "footer.commonmenu1link3",
          },
          {
            href: t("footer.commonmenu1link4Href"),
            textKey: "footer.commonmenu1link4",
          },
          {
            href: t("footer.commonmenu1link5Href"),
            textKey: "footer.commonmenu1link5",
          },
          {
            href: t("footer.commonmenu1link6Href"),
            textKey: "footer.commonmenu1link6",
          },
          {
            href: t("footer.commonmenu1link7Href"),
            textKey: "footer.commonmenu1link7",
          },
          {
            href: t("footer.commonmenu1link8Href"),
            textKey: "footer.commonmenu1link8",
          },
        ],
      },
      {
        key: "bus-services",
        titleKey: "footer.commonmenu2title",
        items: [
          {
            href: t("footer.commonmenu2link1Href"),
            textKey: "footer.commonmenu2link1",
          },
          {
            href: t("footer.commonmenu2link2Href"),
            textKey: "footer.commonmenu2link2",
          },
          {
            href: t("footer.commonmenu2link3Href"),
            textKey: "footer.commonmenu2link3",
          },
          {
            href: t("footer.commonmenu2link4Href"),
            textKey: "footer.commonmenu2link4",
          },
          {
            href: t("footer.commonmenu2link5Href"),
            textKey: "footer.commonmenu2link5",
          },
          {
            href: t("footer.commonmenu2link6Href"),
            textKey: "footer.commonmenu2link6",
          },
          {
            href: t("footer.commonmenu2link7Href"),
            textKey: "footer.commonmenu2link7",
          },
          {
            href: t("footer.commonmenu2link8Href"),
            textKey: "footer.commonmenu2link8",
          },
        ],
      },
      {
        key: "hotel-services",
        titleKey: "footer.commonmenu3title",
        items: [
          {
            href: t("footer.commonmenu3link1Href"),
            textKey: "footer.commonmenu3link1",
          },
          {
            href: t("footer.commonmenu3link2Href"),
            textKey: "footer.commonmenu3link2",
          },
          {
            href: t("footer.commonmenu3link3Href"),
            textKey: "footer.commonmenu3link3",
          },
          {
            href: t("footer.commonmenu3link4Href"),
            textKey: "footer.commonmenu3link4",
          },
          {
            href: t("footer.commonmenu3link5Href"),
            textKey: "footer.commonmenu3link5",
          },
          {
            href: t("footer.commonmenu3link6Href"),
            textKey: "footer.commonmenu3link6",
          },
          {
            href: t("footer.commonmenu3link7Href"),
            textKey: "footer.commonmenu3link7",
          },
          {
            href: t("footer.commonmenu3link8Href"),
            textKey: "footer.commonmenu3link8",
          },
        ],
      },
      {
        key: "car-rental-services",
        titleKey: "footer.commonmenu4title",
        items: [
          {
            href: t("footer.commonmenu4link1Href"),
            textKey: "footer.commonmenu4link1",
          },
          {
            href: t("footer.commonmenu4link2Href"),
            textKey: "footer.commonmenu4link2",
          },
          {
            href: t("footer.commonmenu4link3Href"),
            textKey: "footer.commonmenu4link3",
          },
          {
            href: t("footer.commonmenu4link4Href"),
            textKey: "footer.commonmenu4link4",
          },
          {
            href: t("footer.commonmenu4link5Href"),
            textKey: "footer.commonmenu4link5",
          },
          {
            href: t("footer.commonmenu4link6Href"),
            textKey: "footer.commonmenu4link6",
          },
        ],
      },
      {
        key: "ferry-services",
        titleKey: "footer.commonmenu5title",
        items: [
          {
            href: t("footer.commonmenu5link1Href"),
            textKey: "footer.commonmenu5link1",
          },
          {
            href: t("footer.commonmenu5link2Href"),
            textKey: "footer.commonmenu5link2",
          },
          {
            href: t("footer.commonmenu5link3Href"),
            textKey: "footer.commonmenu5link3",
          },
          {
            href: t("footer.commonmenu5link4Href"),
            textKey: "footer.commonmenu5link4",
          },
          {
            href: t("footer.commonmenu5link5Href"),
            textKey: "footer.commonmenu5link5",
          },
          {
            href: t("footer.commonmenu5link6Href"),
            textKey: "footer.commonmenu5link6",
          },
        ],
      },
      ...commonFooterMenu,
    ],
  };

  return menuData[category] || menuData["common"];
};
